import { useState } from 'react';
import RequestQuotePopup from '../../../components/feature/RequestQuotePopup';

const programmingServicesList = [
  "Lutron Lighting Control Setup and Programming",
  "Savant Programming Support",
  "Lighting Load Schedules and Systems Layout",
  "Scene Creation and Logic Structuring",
  "Keypad and Control Interface Setup",
  "Based on YOUR Project Requirements and platforms"
];

const benefitsList = [
  "Cut down on on-site programming hours",
  "Deliver systems ready for final tuning",
  "Reduce errors before installation begins",
  "Keep projects moving without overloading your team"
];

export default function ProgrammingServices() {
  const [quoteService, setQuoteService] = useState<string | null>(null);

  return (
    <>
      <section className="py-20 bg-gradient-to-b from-white to-gray-50 dark:from-slate-900 dark:to-slate-800 transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#e18033]/10 text-[#e18033] px-4 py-2 rounded-full text-sm font-bold mb-4">
              <i className="ri-code-s-slash-line"></i>
              <span>Specialized Programming</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-gray-100 mb-4">
              Control System Programming
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
              We bring your smart home to life with expert programming for the industry's most reliable control platforms.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            {/* Services List */}
            <div className="bg-white dark:bg-slate-800 rounded-3xl p-8 lg:p-12 shadow-sm border border-gray-100 dark:border-slate-700 hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center gap-4 mb-8">
                <div className="w-14 h-14 rounded-2xl bg-[#e18033]/10 flex items-center justify-center">
                  <i className="ri-list-check-2 text-3xl text-[#e18033]"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">Programming</h3>
              </div>
              <ul className="space-y-5">
                {programmingServicesList.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <div className="mt-1 w-6 h-6 rounded-full bg-[#e18033]/10 dark:bg-[#e18033]/20 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-[#e18033] text-sm"></i>
                    </div>
                    <span className="text-gray-700 dark:text-gray-300 text-lg font-medium">{item}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-12 pt-8 border-t border-gray-100 dark:border-slate-700">
                <button
                  onClick={() => setQuoteService('Programming Services')}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#e18033] hover:bg-[#c9702a] text-white px-8 py-4 rounded-xl font-bold transition-all shadow-lg shadow-orange-200 dark:shadow-none"
                >
                  Request Programming
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>

            {/* Benefits List */}
            <div className="bg-gradient-to-br from-gray-900 to-slate-800 rounded-3xl p-8 lg:p-12 shadow-xl text-white relative overflow-hidden flex flex-col">
              <div className="absolute top-0 right-0 -mt-10 -mr-10 text-white/5 pointer-events-none">
                <i className="ri-timer-flash-line text-9xl"></i>
              </div>
              <div className="relative z-10 flex-1">
                <div className="mb-10">
                  <h3 className="text-3xl md:text-4xl font-bold leading-tight">
                    Reduce Programming Time. <br/>
                    <span className="text-[#e18033]">Improve Project Flow.</span>
                  </h3>
                </div>
                <ul className="space-y-4">
                  {benefitsList.map((item, idx) => (
                    <li key={idx} className="flex items-center gap-4 bg-white/5 rounded-2xl p-5 border border-white/10 hover:bg-white/10 transition-colors backdrop-blur-sm">
                      <div className="w-8 h-8 rounded-full bg-[#e18033]/20 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-double-line text-[#e18033]"></i>
                      </div>
                      <span className="text-gray-100 text-lg font-medium">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="relative z-10 mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                <div className="flex items-center gap-3 text-white/80">
                  <i className="ri-mail-send-line text-2xl text-[#e18033]"></i>
                  <a href="mailto:drafting@digitalmediainnovations.com" className="font-medium hover:text-white transition-colors">drafting@digitalmediainnovations.com</a>
                </div>
                <div className="flex items-center gap-3 text-white/80">
                  <i className="ri-phone-line text-2xl text-[#e18033]"></i>
                  <a href="tel:3038731100" className="font-medium hover:text-white transition-colors">(303) 873-1100</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RequestQuotePopup
        isOpen={!!quoteService}
        onClose={() => setQuoteService(null)}
        serviceName={quoteService || undefined}
      />
    </>
  );
}
